import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, Content } from 'ionic-angular';
import { RcsKdDataServiceProvider } from '../../providers/rcs-kd-data-service/rcs-kd-data-service';

import { StackService } from '../../providers/odoo/stack.service';

@IonicPage()
@Component({
  selector: 'page-calender',
  templateUrl: 'calender.html'
})
export class CalenderPage implements OnInit{

  @ViewChild(Content) content: Content;
  public show_searchbar: boolean
  public search_terms: Array<string>
  private all_jobs: Array<any>
  public sorted_jobs: Array<any>

  constructor(public nav_controller: NavController,
              private data_service: RcsKdDataServiceProvider,
              private stack: StackService) {}

  ngOnInit(): void {}

  ionViewWillEnter(){
    this.search_terms = [];
    this.data_service.get_jobs().subscribe(
      result => {
        let jobs: any = this.filter_jobs(result);
        this.all_jobs = jobs;
      },
      error => {},
      () => { this.search(); }
    )
  }

  private filter_jobs(jobs){
    let filtered_jobs = []
    for (let job of jobs){
      if (job.state_name !== 'erledigt'){
        filtered_jobs.push(job)
      }
    }
    return filtered_jobs;
  }

  public set_searchmode_mode(){
    if(this.show_searchbar){
      this.show_searchbar = false;
      this.content.resize();
    }else{
      this.show_searchbar = true;
      this.content.resize();
    }
  }

  public get_search_terms(search_terms){
    this.search_terms = search_terms;
    this.search();
  }

  public search(){
    if (this.search_terms.length > 0){
      this.search_jobs();
    }else{
      this.create_calender_dates(this.all_jobs);
    }
  }

  public search_jobs(){
    for(let term of this.search_terms){

      let results = []
      for (let job of this.all_jobs){
        const regex = new RegExp(term, 'i');
        if (job.name.match(regex) !== null || job.date_planned.match(regex) !== null || job.description.match(regex) !== null){
          results.push(job);
        }
      }
      this.create_calender_dates(results);
    }
  }

  public sort(jobs:Array<any>){
    let sorted_jobs = jobs.sort(function(a, b){
      if (a.name && b.name){
        if (a.name.toUpperCase() < b.name.toUpperCase()) { return 1 }
        return 0;
      }
    });
    return sorted_jobs;
  }

  public doRefresh(refresher) {
    setTimeout(() => {
      if (this.stack.getNetworkState()){
        this.stack.running();
        this.data_service.sync_jobs().subscribe(
          flag_finish => {
            flag_finish.subscribe(
              data => {
                refresher.complete();
                this.nav_controller.setPages([{'page': 'CalenderPage', 'params': {}}]);
              },
            )
          }
        )
      }
    }, 1000);
  }

  public create_calender_dates(jobs){
    let dates = [];
    this.sorted_jobs = [];
    dates.push(new Date());
    dates.push(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
    dates.push(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 2));

    for (let date of dates){
      let current_jobs = [];
      for (let job of jobs){
        if (new Date(job.date_planned).setHours(0,0,0,0) === date.setHours(0,0,0,0)){
          current_jobs.push(job);
        }
      }

      this.sorted_jobs.push(
        {'date': date, 'jobs': current_jobs}
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/calender/calender.ts